import { organizationService } from '@/service/organization';

export interface OrganizationData {
  name: string,
  slug: string,
  description: string,
  kintone_url?: string,
  kintone_email?: string,
  kintone_password?: string,
  createdAt?: string,
  updatedAt?: string,
}

export class Organization {
  constructor(private slug?: string) { }

  async all(): Promise<OrganizationData[] | undefined> {
    try {
      return await organizationService.getAll() as OrganizationData[];
    } catch (e) {
      console.warn(e);
    }
  }

  async get(): Promise<OrganizationData | undefined> {
    try {
      return await organizationService.getOne(`${this.slug}`) as OrganizationData;
    } catch (e) {
      console.warn(e);
    }
  }

  async add(project: OrganizationData): Promise<string | undefined> {
    try {
      return await organizationService.add(project);
    } catch (e) {
      console.warn(e);
    }
  }

  async update(project: OrganizationData): Promise<string | undefined> {
    try {
      return await organizationService.update(`${this.slug}`, project);
    } catch (e) {
      console.warn(e);
    }
  }

  async delete(): Promise<boolean> {
    try {
      return await organizationService.delete(`${this.slug}`);
    } catch (e) {
      console.warn(e);
      return false;
    }
  }


}

